import { PARTNER_COMPANY_REGISTER_LOAD_FROM } from './constants';

// 協力会社一覧から遷移した場合と施工体系図から遷移した場合と分けるための判定
export const loadFromFieldTreePage = loadFrom => {
  if (loadFrom === PARTNER_COMPANY_REGISTER_LOAD_FROM.FIELD_TREE_PAGE) {
    return true;
  }
  return false;
};

// 協力会社一覧から遷移した場合と施工体系図から遷移した場合と分けるための判定
export const loadFromPartnerCompanies = loadFrom => {
  if (loadFrom === PARTNER_COMPANY_REGISTER_LOAD_FROM.PARTNER_COMPANIES) {
    return true;
  }
  return false;
};

export const loadFromAgencyRegister = loadFrom => {
  if (loadFrom === PARTNER_COMPANY_REGISTER_LOAD_FROM.AGENCY_REGISTER) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/utilities/partnerCompanyRegisterUtil.js